import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UsersAvatarsCategoryItem } from '../../../../common-shared/ui-widgets';
import { ApiRequestBuilder, ApiService } from '../../../../common-shared/api';
import { NotificationsService } from '../../../../common-shared/notifications';

import {
  EntityMSUserInfos,
  MSUserInfo,
  MSUsersAll,
  TenantComplianceFormEntityType,
} from '../../../../../../backend-core-lib/app/common-shared/account/models';

import { cloneDeep, get } from 'lodash';
import {
  EntityCommonDataInfoItem,
  EntityCommonPreferencesGroup,
  EntityCommonTable,
} from '../../types/entity-info-types';

@Component({
  selector: 'entity-info',
  templateUrl: './entity-info.component.html',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class EntityInfoComponent implements OnChanges {
  @HostBinding('class')
  readonly cssClass = 'entity-info';

  @Input()
  entity!: EntityCommonTable;

  @Input()
  entityType!: TenantComplianceFormEntityType;

  @Input()
  showDrawer = false;

  @Input()
  environmentUid!: string;

  /*New */
  @Input()
  sidebarOptions: string[] = ['overview', 'preferences', 'compliance'];

  sidebarOptionsFiltered: string[] = ['overview', 'preferences', 'compliance'];

  @Input()
  preferencesGroups: EntityCommonPreferencesGroup[] = [];

  @Input()
  dataItems: EntityCommonDataInfoItem[] = [];

  @Output()
  entityChange = new EventEmitter<EntityCommonTable>();

  @Output()
  showDrawerChange = new EventEmitter<boolean>();

  selectedSidebarOption: string = 'overview';

  lastEntityUid = '';

  owner: UsersAvatarsCategoryItem[] = [];
  deputies: UsersAvatarsCategoryItem[] = [];
  shared: UsersAvatarsCategoryItem[] = [];

  availableUsers: MSUserInfo[] | undefined = undefined;

  constructor(
    private apiService: ApiService,
    private notificationsService: NotificationsService,
  ) {}
  ngOnChanges() {
    const currentEnvironmentUid = this.entity?.uid as string;
    this.refreshSideBarOption();
    if (this.lastEntityUid !== currentEnvironmentUid) {
      this.updateOwnerDeputies();
      this.getListAvailableUsers();
    }
    this.lastEntityUid = currentEnvironmentUid;
  }
  refreshSideBarOption(): void {
    if (this.entity.__enableCompliance) {
      this.sidebarOptionsFiltered = cloneDeep(this.sidebarOptions);
    } else {
      this.sidebarOptionsFiltered = cloneDeep(this.sidebarOptions).filter(
        (e) => e !== 'compliance',
      );
    }
  }
  updateOwnerDeputies(): void {
    this.owner = this.entity?.data?.owner ? [this.entity.data.owner] : [];
    this.deputies = this.entity?.data?.deputies || [];
    this.shared = this.entity?.data?.shared || [];
    this.availableUsers = undefined;
  }

  onHideDrawer(): void {
    console.log('onHideDrawer');
    this.showDrawerChange.emit(false);
  }
  async onFlagChange(event: boolean, flagId: string): Promise<void> {
    console.log(event, flagId);
    const updateFlagRequest = new ApiRequestBuilder('setEnvironmentFlag')
      .replaceUrl({
        environmentUid: this.environmentUid,
        entityId: this.entity?.uid,
        entityType: this.entityType,
        flagId: flagId,
        flagValue: event,
      })
      .build();

    const updateFlagResponse = await this.apiService.callApi(updateFlagRequest);
    if (updateFlagResponse.status === 'success' && updateFlagResponse.data) {
      this.entityChange.emit(updateFlagResponse.data);
    }
  }
  async changeTabSelect(): Promise<void> {
    console.log(this.selectedSidebarOption);
  }
  async confirmActivity(): Promise<void> {
    const confirmActivityRequest = new ApiRequestBuilder(
      'confirmEntityActivity',
    )
      .replaceUrl({
        environmentUid: this.environmentUid,
        entityId: this.entity?.uid,
        entityType: this.entityType,
      })
      .build();

    const confirmActivityResponse = await this.apiService.callApi(
      confirmActivityRequest,
    );
    if (
      confirmActivityResponse.status === 'success' &&
      confirmActivityResponse.data
    ) {
      this.entityChange.emit(confirmActivityResponse.data);
    }
  }
  showActivityConfirmation(): boolean {
    const lastNotified = this.entity?.data?.lastNotifiedAt ?? 0;
    const lastConfirmed = this.entity?.data?.lastConfirmedAt ?? 0;
    return !!lastNotified && (!lastConfirmed || lastNotified > lastConfirmed);
  }
  getFlags(): any {
    return this.entity?.data?.flags as unknown as any;
  }
  getDataItemValue(item: EntityCommonDataInfoItem): any {
    return get(this.entity, item.valuePath, '');
  }
  onChangedOwner(owner: UsersAvatarsCategoryItem[]): void {
    /*this.entityChange.emit({
      ...this.entity,
      data: {
        ...this.entity.data,
        owner: owner?.length ? owner[0] : undefined,
      },
    });*/
  }
  onChangedDeputies(deputies: UsersAvatarsCategoryItem[]): void {
    /*this.entityChange.emit({
      ...this.entity,
      data: {
        ...this.entity.data,
        deputies: deputies,
      },
    }); */
  }

  onChangedShared(shared: UsersAvatarsCategoryItem[]): void {
    /*this.entityChange.emit({
      ...this.entity,
      data: {
        ...this.entity.data,
        shared: shared,
      },
    });*/
  }

  onAllUsersChange(onAllUsersChange: EntityMSUserInfos): void {
    this.processedAssignedUsers(onAllUsersChange);
    this.entityChange.emit({
      ...this.entity,
      data: {
        ...this.entity.data,
        owner: onAllUsersChange.owner,
        deputies: onAllUsersChange.deputies,
        shared: onAllUsersChange.shared,
      },
    });
  }

  async onFetchUsers(): Promise<void> {
    if (this.availableUsers === undefined) {
      await this.getListAvailableUsers();
    }
  }

  isNonSolutionFlow(): boolean {
    return this.entityType === 'FLOW' && !this.entity?.data?.workflowSolutionId;
  }
  async getListAvailableUsers(): Promise<void> {
    try {
      const getUserRequest = new ApiRequestBuilder('getEnvironmentUsers')
        .replaceUrl({
          environmentUid: this.environmentUid,
          entityType: this.entityType,
          entityId: this.entity.uid,
          userType: 'owner',
        })
        .build();

      const resultApi = await this.apiService.callApi(getUserRequest);
      if (!resultApi || resultApi.status === 'error') {
        return resultApi.data || 'ServerUnreachable';
      }
      const apiData = resultApi.data as MSUsersAll;
      if (apiData) {
        this.availableUsers = apiData.available;

        this.processedAssignedUsers(apiData.assigned);
        /* this.deputies = apiData.assigned.deputies as MSUserInfo[];
        this.owner = (
          apiData.assigned?.owner ? [apiData.assigned.owner] : []
        ) as MSUserInfo[];
        this.shared = apiData.assigned.shared as MSUserInfo[];*/
        this.entityChange.emit({
          ...this.entity,
          data: {
            ...this.entity.data,
            shared: this.shared,
            owner: this.owner?.length ? this.owner[0] : undefined,
            deputies: this.deputies,
          },
        });
      }
    } catch (e) {}
  }
  processedAssignedUsers(assignedUsers: EntityMSUserInfos) {
    this.deputies = assignedUsers.deputies as MSUserInfo[];
    this.owner = (
      assignedUsers?.owner ? [assignedUsers.owner] : []
    ) as MSUserInfo[];
    this.shared = assignedUsers.shared as MSUserInfo[];
  }
}
